import { animate, style, transition, trigger } from '@angular/animations';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { afterRender, Component, Input } from '@angular/core';
import { TitleExtractorPipe } from 'src/app/pipe/product-title.pipe';

@Component({
  selector: 'app-sticky-add-to-cart',
  imports: [NgIf, NgOptimizedImage, TitleExtractorPipe],
  templateUrl: './sticky-add-to-cart.component.html',
  styleUrl: './sticky-add-to-cart.component.scss',
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' })
        ),
      ]),
      transition(':leave', [
        animate(
          '300ms ease-in',
          style({ opacity: 0, transform: 'translateY(20px)' })
        ),
      ]),
    ]),
  ],
})
export class StickyAddToCartComponent {
  @Input() product: any;
  isOutOfView: boolean = false;
  scrollTo() {
    window.scrollTo({
      behavior: 'smooth',
      top: window!
        .document!.querySelector('app-variant-picker')
        ?.getBoundingClientRect().top,
    });
  }

  private observer!: IntersectionObserver;

  constructor() {
    afterRender(() => {
      if (window) {
        const target = window!.document!.querySelector('app-variant-picker');
        if (!target) {
          return;
        }

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.isOutOfView = !entry.isIntersecting;
          },
          { threshold: 0 }
        );

        this.observer.observe(target);
      }
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
